// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__F6Kwy","hero":"styles_hero__Ansu7","title":"styles_title__sV1UK"};